<div class="pdf-view-ust-veri-area">
    <div  class="form-content" >
      <dx-form id="form" #form [(formData)]="bysBelge" [colCount]="1" [showColonAfterLabel]="true"
        [labelMode]="labelMode" [labelLocation]="labelLocation" [readOnly]="isReadOnly">
    
    
     
    
    
        <dxi-item itemType="group" cssClass="form-multiple-row" [colCount]="2" [colSpan]="1">
          <dxi-item itemType="group" [colCount]="4" [colSpan]="2">
            
            <dxi-item [dataField]="gelenGiden==='G'?'GelenBirimKod':'BirimKod'" [label]="{ text: gelenGiden==='G'?'Gelen Birim':'Birimi' }"
            >
            <dk-ctl-vgen-birim
            [code]="gelenGiden==='G'?bysBelge?.GelenBirimKod:bysBelge?.BirimKod" [labelText]="gelenGiden==='G'?'Gelen Birim':'Birimi'"  [isReadOnly]="isReadOnly"
            [isActive]="false" [birimTuru]="'A'"
            [labelMode]="labelMode" [isOnlyGrid]="true"
            ></dk-ctl-vgen-birim>
          </dxi-item>
        </dxi-item>
        
        
        <dxi-item itemType="group" [colCount]="4" [colSpan]="2">
          <dxi-item [label]="{ text: 'SDP Kodu' }" dataField="DosyaPlanKod" >
            <dk-ctl-gen-kontrol 
            #control [isReadOnly]="isReadOnly" [labelText]="'SDP Kodu'" [code]="bysBelge?.DosyaPlanKod"
              [controlName]="'GenDosyaPlanGenel'" [labelMode]="labelMode"></dk-ctl-gen-kontrol>
      
          </dxi-item>
          </dxi-item>
  
          <dxi-item [label]="{ text: 'Konu' }" dataField="BelgeAdi">
          </dxi-item>
    
          <dxi-item [label]="{ text: 'Özel No' }" dataField="OzelNo">
          </dxi-item>
  
          <dxi-item itemType="group" [colCount]="2">
            
            <dxi-item [label]="{ text: 'Dağıtım Tür' }" dataField="DagitimSekli">
              <dk-ct-gen-lookup  [labelMode]="labelMode" [selectedValue]="bysBelge?.DagitimSekli" [valueExpr]="'ozelKod'"
              (valueChange)="bysBelge.DagitimSekli = $event.value" [lookUpType]="'BYS_DAGITIM_SEKLI_LOOKUP'" [readOnly]="isReadOnly"
              [label]="'Dagıtım Tür'"></dk-ct-gen-lookup>
            </dxi-item>
          </dxi-item>
          
          <dxi-item itemType="group" [colCount]="2">
            <dxi-item [label]="{ text: 'Belge Tipi' }" dataField="BelgeTuru">
              <dk-ct-gen-lookup [placeholder]="'Belge Tipi'" [labelMode]="labelMode" [selectedValue]="bysBelge?.BelgeTuru"
              (valueChange)="bysBelge.BelgeTuru = $event.value" [lookUpType]="'BYS_YAZIISMA_ORTAM_TUR'" [readOnly]="isReadOnly"
              [label]="'Belge Tipi'"></dk-ct-gen-lookup>
            </dxi-item>
          </dxi-item>
          
          <dxi-item dataField="GuvenlikDurumu" [label]="{ text: 'Gizlilik' }">
            
            <dk-ct-gen-lookup [placeholder]="'Gizlilik'" [labelMode]="labelMode" [selectedValue]="bysBelge?.GuvenlikDurumu" [valueExpr]="'kod'"
            (valueChange)="bysBelge.GuvenlikDurumu = $event.value" [lookUpType]="'BYS_GUVENLIK_DURUM_LOOKUP'" [readOnly]="isReadOnly"
            [label]="'Gizlilik'"></dk-ct-gen-lookup>
          </dxi-item>
          <dxi-item dataField="GuvenlikDurumu" [label]="{ text: 'Gizlilik' }">
        </dxi-item>
        
        
        <dxi-item itemType="group" [colCount]="2">
        <dxi-item [label]="{ text: 'Öncelik ' }" dataField="OncelikDurumu">
          <dk-ct-gen-lookup [placeholder]="'Öncelik'" [labelMode]="labelMode" [selectedValue]="bysBelge?.OncelikDurumu" [valueExpr]="'ozelKod'"
          (valueChange)="bysBelge.OncelikDurumu = $event.value" [lookUpType]="'BYS_ONCELIK_DURUMU_LOOKUP'" [readOnly]="isReadOnly"
          [label]="'Öncelik'"></dk-ct-gen-lookup>
        </dxi-item>
      </dxi-item>
      
      <dxi-item [label]="{ text: 'Cevap tarihi' }" dataField="BeklenenDonusTarih" editorType="dxDateBox">
      </dxi-item>
      
      
      <dxi-item itemType="group" [colCount]="2">
          <dxi-item [label]="{ text: 'Belge Dili ' }" dataField="DilKod">
            
            <dk-ct-gen-lookup [placeholder]="'Belge Dili'" [labelMode]="labelMode" [selectedValue]="bysBelge?.DilKod" [valueExpr]="'kod'"
            (valueChange)="bysBelge.DilKod = $event.value" [lookUpType]="'GKOD_BELGE_YAZISMA_DIL'" [readOnly]="isReadOnly"
            [label]="'Belge Dili'"></dk-ct-gen-lookup>
          </dxi-item>
          </dxi-item>
    
          <dxi-item itemType="group" [colCount]="2" [colSpan]="2">

            <dxi-item [label]="{ text: 'Ada/Parsel' }" dataField="Ada" editorType="dxNumberBox">
            </dxi-item>
            <dxi-item [label]="{ text: '/' }" dataField="Parsel" editorType="dxNumberBox">
            </dxi-item>
          </dxi-item>
  
          
          <dxi-item [label]="{ text: 'Anahtar' }" dataField="AnahtarKelime" editorType="dxTextArea">
          </dxi-item>
      
          <dxi-item [label]="{ text: 'Açıklama' }" dataField="BelgeAciklama" editorType="dxTextArea">
          </dxi-item>
    
    
          <dxi-item [label]="{ text: 'Bilgi Ad Soyad' }" dataField="BilgiAdSoyad">
          </dxi-item>
    
          <dxi-item [label]="{ text: 'Bilgi Unvani' }" dataField="BilgiUnvani">
          </dxi-item>
    
          <dxi-item [label]="{ text: 'Bilgi Telefon' }" dataField="BilgiTelNo">
          </dxi-item>
    
          <dxi-item [label]="{ text: 'Bilgi E-Posta' }" dataField="BilgiEPosta">
          </dxi-item>
        </dxi-item>
    
    
    
    
    
         
    
    
    
        <dxi-item cssClass="header" itemType="group" caption="Diğer Bilgiler">
    
          <dxi-item dataField="KisiKod">
            <dk-ctl-gen-kisi 
            #control [code]="bysBelge?.KisiKod" [labelText]="'Kişi'" [isReadOnly]="isReadOnly"
              [labelMode]="labelMode"></dk-ctl-gen-kisi>
          </dxi-item>
    
          <dxi-item dataField="PersonelKod">
            <dk-ctl-ika-personel 
            #control [labelText]="'Personel'" [code]="bysBelge?.PersonelKod" [isReadOnly]="isReadOnly"
              [labelMode]="labelMode"></dk-ctl-ika-personel>
          </dxi-item>
    
        </dxi-item>
    
      </dx-form>
      <div class="eyp-area" *ngIf="bysBelgeDetay">
        <span>Eyp Durumu: {{bysBelgeDetay?.EypStatus === 1?'İmzada':bysBelgeDetay?.EypStatus === 2?'İmzalandı':''}}</span>
        <dx-button *ngIf="bysBelgeDetay?.EypDysId?true:false" width="100px" icon="download"
        stylingMode="contained" type="default" text="Eyp İndir" (click)="eypIndirClick()"></dx-button>
    
      </div>
      
    
      
      <dx-load-panel #loadPanel container="#form" [showIndicator]="true" shadingColor="rgba(0,0,0,0.2)"
      [showPane]="false" [shading]="true" [visible]="(isLoading && state === 'Edit')" [position]="{ of: '#form' }"></dx-load-panel>
    </div>
  </div>